class ThreeColumnMenu extends HTMLElement {
  constructor() {
    super();
    this._init = false;
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.init();
  }

  init() {
    if (this._init) return;
    this._init = true;
    this.dataset.initialized = 'true';

    // Cache DOM references
    this.l1Items = this.querySelectorAll('.three-column-menu__item--l1');
    this.l2Lists = this.querySelectorAll('.three-column-menu__list--l2');
    this.l3Lists = this.querySelectorAll('.three-column-menu__list--l3');

    // Bind handlers
    this._onL1Hover = this.handleL1Hover.bind(this);
    this._onL2Hover = this.handleL2Hover.bind(this);

    // Attach L1 hover events
    this.l1Items.forEach((item) => {
      item.addEventListener('mouseenter', this._onL1Hover);
    });

    // Attach L2 hover events (delegation for dynamically visible items)
    this.addEventListener('mouseover', (event) => {
      const l2Item = event.target.closest('.three-column-menu__item--l2');
      if (l2Item) {
        this.handleL2Hover(l2Item);
      }
    });
  }

  handleL1Hover(event) {
    const targetItem = event.currentTarget;
    const level1Id = targetItem.dataset.level1Id;

    if (!level1Id) return;

    // Update L1 active state
    this.l1Items.forEach((item) => item.classList.remove('is-active'));
    targetItem.classList.add('is-active');

    // Show corresponding L2 list
    this.l2Lists.forEach((list) => {
      const isMatch = list.dataset.level1Id === level1Id;
      list.classList.toggle('is-active', isMatch);

      // If showing this L2 list, activate its first item and show its L3
      if (isMatch) {
        const firstL2Item = list.querySelector('.three-column-menu__item--l2');
        if (firstL2Item) {
          this.activateL2WithL3(firstL2Item, level1Id);
        } else {
          // No L2 items — hide all L3 lists for this L1
          this.activateL3ForLevel2(null, level1Id);
        }
      }
    });
  }

  handleL2Hover(l2Item) {
    // Handle both direct call and event delegation
    if (l2Item instanceof Event) {
      return; // handled by delegation below
    }

    const level2Id = l2Item.dataset.level2Id;
    if (!level2Id) return;

    // Get the parent L1 context
    const parentList = l2Item.closest('.three-column-menu__list--l2');
    const level1Id = parentList ? parentList.dataset.level1Id : null;

    // Update L2 active state (only within the visible L2 list)
    if (parentList) {
      parentList.querySelectorAll('.three-column-menu__item--l2').forEach((item) => {
        item.classList.remove('is-active');
      });
    }
    l2Item.classList.add('is-active');

    this.activateL3ForLevel2(level2Id, level1Id);
  }

  activateL2WithL3(l2Item, level1Id) {
    // Reset all L2 items in this list
    const parentList = l2Item.closest('.three-column-menu__list--l2');
    if (parentList) {
      parentList.querySelectorAll('.three-column-menu__item--l2').forEach((item) => {
        item.classList.remove('is-active');
      });
    }
    l2Item.classList.add('is-active');

    const level2Id = l2Item.dataset.level2Id;
    if (level2Id) {
      this.activateL3ForLevel2(level2Id, level1Id);
    }
  }

  activateL3ForLevel2(level2Id, level1Id) {
    // Show corresponding L3 list — filtered by BOTH level1Id and level2Id
    this.l3Lists.forEach((list) => {
      const isMatch = list.dataset.level2Id === level2Id && list.dataset.level1Id === level1Id;
      list.classList.toggle('is-active', isMatch);
    });
  }

  disconnectedCallback() {
    this.l1Items.forEach((item) => {
      item.removeEventListener('mouseenter', this._onL1Hover);
    });
  }
}

customElements.define('three-column-menu', ThreeColumnMenu);
